import { CustomList } from "components/index";
import React from "react";
import { startOfMonth, endOfMonth } from "date-fns";
import { DisplayAmount } from "components/display/amount";
import { formatDateForAPI, ROUTE } from "@/lib/utils";
import { DateCell } from "@/modules/work/billables/cells";
import { MonthPickerButton } from "components/month-picker-button";
import { StatusCell } from "@/components/status/cell";
import { EmployeeCell } from "components/cell/employee/cell";
import { Link } from "react-router-dom";

const MonthlySlippageListFilters = ({ filters, setFilters }) => {
  // Convert stored date string back to Date object for display
  const selectedMonth = filters?.startDate ? new Date(filters.startDate) : null;

  return (
    <MonthPickerButton
      selectedMonth={selectedMonth}
      onMonthSelect={(month) => {
        if (month) {
          const start = startOfMonth(month);
          const end = endOfMonth(month);
          setFilters({
            ...filters,
            startDate: formatDateForAPI(start),
            endDate: formatDateForAPI(end),
          });
        }
      }}
      onClear={() => {
        const { startDate, endDate, ...rest } = filters;
        setFilters(rest);
      }}
      placeholder="Select month"
      className="w-full"
    />
  );
};

const MonthlySlippageList = () => {
  const columns = [
    {
      id: "billable",
      header: "Billable",
      accessorKey: "name",
      cell: ({ row }) => {
        const name = row.getValue("billable");

        return (
          <div className="space-y-1" title={name}>
            <Link to={`${ROUTE.BILLABLE(row.original.id)}`} target="_blank">
              <div className="hover:underline">{name ?? "__"}</div>
            </Link>
          </div>
        );
      },
      footer: () => {
        return "Total";
      },
    },
    {
      id: "company",
      header: "Company",
      accessorKey: "company",
    },
    {
      id: "amount",
      header: "Amount",
      accessorKey: "amount",
      cell: ({ getValue, row }) => {
        const value = getValue();
        const isPositive = row.original.isPositive;
        if (!value) return null;

        const colorClass = isPositive ? "text-green-600" : "text-red-600";

        return <DisplayAmount value={value} className={colorClass} />;
      },
      footer: (totals) => {
        return <DisplayAmount value={totals?.amount} />;
      },
    },
    // {
    //   id: "year_month",
    //   header: "Month",
    //   accessorKey: "year_month",
    //   cell: ({ getValue }) => {
    //     const value = getValue();
    //     if (!value) return null;
    //     // Format YYYY-MM to MMM YYYY
    //     const [year, month] = value.split("-");
    //     const date = new Date(year, parseInt(month) - 1, 1);
    //     return format(date, "MMM yyyy");
    //   },
    // },
    // {
    //   id: "project_name",
    //   header: "Project",
    //   accessorKey: "project_name",
    // },
    {
      id: "billing_date",
      header: "Billing Date",
      accessorKey: "billing_date",
      cell: DateCell,
    },
    {
      id: "invoice_or_extended_date",
      header: "Invoice/Extended Date",
      accessorKey: "invoice_or_extended_date",
      cell: DateCell,
    },
    {
      id: "slippage_type",
      header: "Type",
      accessorKey: "slippage_type",
      cell: StatusCell,
    },
    {
      id: "slippage_by_days",
      header: "Slippage Days",
      accessorKey: "slippage_by_days",
      cell: ({ getValue }) => {
        const days = getValue();

        if (days === null || days === undefined) return null;

        const displayValue = days;

        return (
          <div className="font-medium">
            {displayValue} {displayValue === 1 ? "day" : "days"}
          </div>
        );
      },
    },
    {
      id: "account_manager",
      header: "AM",
      accessorKey: "account_manager",
      cell: EmployeeCell,
    },
    {
      id: "sales_coordinator",
      header: "SC",
      accessorKey: "sales_coordinator",
      cell: EmployeeCell,
    },
  ];

  // Set default filter to current month
  const currentDate = new Date();
  const defaultFilters = {
    startDate: formatDateForAPI(startOfMonth(currentDate)),
    endDate: formatDateForAPI(endOfMonth(currentDate)),
  };

  return (
    <CustomList
      endPoint="custom-ui/slippage-billing-difference"
      title="Monthly Slippage List"
      columns={columns}
      hidePagination={true}
      storageKey="monthly-slippage-list"
      renderFilters={MonthlySlippageListFilters}
      inlineFilters={true}
      filters={defaultFilters}
    />
  );
};

export default MonthlySlippageList;
